import { IWidgetsListProps } from '@libs/types';
import * as React from 'react';
import { default as Widget } from './Widget';

export const makeWidgetsList = (Widget: React.ElementType) => {
    const WidgetsList = ({ uids, widgets }: IWidgetsListProps) => {
        if (Array.isArray(uids) && typeof uids[0] === 'string') {
            return uids?.map((uid) => <Widget uid={uid} Package={WidgetsList} key={uid} />);
        } else if (Array.isArray(widgets)) {
            return widgets?.map((widget) => <Widget widget={widget} Package={WidgetsList} key={widget?.uid} />);
        }
        return false;
    };
    return WidgetsList;
};

export const WidgetsList: React.FC<IWidgetsListProps> = ({ uids, widgets }) => {
    if (Array.isArray(uids) && typeof uids[0] === 'string') {
        return uids?.map((uid) => <Widget uid={uid} Package={WidgetsList} key={uid} />);
    } else if (Array.isArray(widgets)) {
        return widgets?.map((widget) => <Widget widget={widget} Package={WidgetsList} key={widget?.uid} />);
    }
    return false;
};
